export default __webpack_public_path__ + "static/media/scrolls.41923f4d.png";